<template>
  <div class="player-adder">
    <b-field grouped group-multiline label="Add Player">
      <b-field label="Email">
        <b-input placeholder="Email" icon="envelope" type="email"></b-input>
      </b-field>
      <b-field label="Name">
        <b-input placeholder="Name" icon="user-circle" type="text"></b-input>
      </b-field>
      <b-field label="Phone Number">
        <b-input placeholder="Phone Number" icon="mobile" type="tel"></b-input>
      </b-field>
      <button type="button" class="button is-primary">Add Player<span class="fas fa-plus"></span></button>
    </b-field>
  </div>
</template>

<script>
  export default {
    name: "PlayerAdder"
  }
</script>

<style scoped lang="scss">

</style>